// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"CardSpinner_spinnerContainer__3ssV4"};